export const ACTIONS = {
    CREATE: 'CREATE',
    START: 'START',
    PAUSE: 'PAUSE',
    RESUME: 'RESUME',
    COMPLETE: 'COMPLETE',
    RESET: 'RESET',
    TICK: 'TICK',
};

export const STRATEGY = {
    START_BY_FIRST_USER: 'first-user',
    START_WHEN_ALL_USERS: 'all-users',
};


// WEBPACK FOOTER //
// ./src/service/timer-service/timer-constants.js